import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DashboardFormSection from 'components/dashboard/common/DashboardFormSection';
import GoogleAdsenseSwitcher from 'components/dashboard/earn-content/adsense/GoogleAdsenseSwitcher';
import ConnectAdsenseForm from 'components/dashboard/earn-content/adsense/ConnectAdsenseForm';
import GoogleAdsenseSettings from 'components/dashboard/earn-content/adsense/GoogleAdsenseSettings';
import FixedNotification from 'components/common/FixedNotification';

import './AdsenseMainContent.css';


function AdsenseMainContent(props) {
  const { me } = props;
  const { t } = useTranslation();

  const [idSaved, setIdSaved] = useState(false);
  const [idChanged, setIdChanged] = useState(false);

  if (!me) return null;

  const calculateExpandMode = () => {
    if (me.adsense_publisher_id) {
      if (idSaved || idChanged) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  };

  return (
    <DashboardFormSection
      className="adsense-main-content__component"
      header={t("GOOGLE ADSENSE PREMIUM ACCESS")}
      expanded={me.adsense_publisher_id}
      defaultExpandMode={calculateExpandMode()}
    >
      <div className="header-wrapper">
        <GoogleAdsenseSwitcher />
      </div>

      <div className="info-wrapper">
        <div>
          <strong>{t("HeyLink.me has partnered with Google")}</strong> {t("to allow you to earn money by showing ads on your HeyLink.me page.")}
        </div>
        <div>
          {t("You need to adhere to")}&nbsp;
          <a
            href="https://support.google.com/adsense/answer/48182?hl=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("Google policies")}
          </a>, {t("so please read them carefully.")}
        </div>
        <div>
          <strong>{t("Your AdSense Revenue Share: 50%")}</strong>
        </div>
      </div>

      <div className="content-wrapper">
        {!me.adsense_publisher_id ?
          <ConnectAdsenseForm setIdSaved={setIdSaved} />
          :
          <GoogleAdsenseSettings setIdChanged={setIdChanged} />
        }
      </div>

      {idSaved &&
        <FixedNotification
          onFadeComplete={() => setIdSaved(false)}
        >
          <h2>{t("Congratulations!")}</h2>
          <div>{t("You've enabled Google Ads on your HeyLink.me site")}</div>
        </FixedNotification>
      }

      {idChanged &&
        <FixedNotification
          onFadeComplete={() => setIdChanged(false)}
        >
          <h2>{t("Congratulations!")}</h2>
          <div>{t("You've changed your Publisher ID")}</div>
        </FixedNotification>
      }
    </DashboardFormSection>
  );
}

AdsenseMainContent.propTypes = {
  me: PropTypes.object,
};

AdsenseMainContent.propTypes = {
  me: null,
};

export default AdsenseMainContent;
